import React, { useRef } from 'react';
import { useSpeechInput } from '../../hooks/useSpeechInput';
import { parseICAOSigla } from '../../utils/icaoParser';

interface SiglaICAOInputProps {
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  hint?: string;
}

const SiglaICAOInput: React.FC<SiglaICAOInputProps> = ({
  value, onChange, placeholder = 'es. TF 014', hint,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const { isListening, isSupported, isModelReady, startListening, stopListening } = useSpeechInput({
    onResult: (text) => {
      const sigla = parseICAOSigla(text);
      onChange(sigla);
    },
    onError: () => {},
  });

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
      <div style={{ position: 'relative' }}>
        <input
          ref={inputRef}
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value.toUpperCase())}
          placeholder={placeholder}
          maxLength={20}
          style={{
            width: '100%',
            padding: '10px 40px 10px 12px',
            background: '#0f1623',
            border: `1px solid ${isListening ? '#dc2626' : '#1e3a5f'}`,
            borderRadius: 6,
            color: '#e2e8f0',
            fontSize: 18,
            fontWeight: 700,
            letterSpacing: 3,
            outline: 'none',
            boxSizing: 'border-box',
            textTransform: 'uppercase',
          }}
        />
        {isSupported && (
          <button
            type="button"
            onMouseDown={(e) => e.preventDefault()}
            onClick={isListening ? stopListening : startListening}
            title={isListening ? 'Ferma dettatura' : isModelReady ? 'Ditta in alfabeto ICAO (es. Tango Foxtrot zero uno quattro)' : 'Modello in caricamento…'}
            style={{
              position: 'absolute',
              right: 6,
              top: '50%',
              transform: 'translateY(-50%)',
              background: isListening ? 'rgba(220,38,38,0.15)' : 'transparent',
              border: 'none',
              color: isListening ? '#ef4444' : '#64748b',
              cursor: 'pointer',
              padding: '4px 6px',
              borderRadius: 4,
              fontSize: 18,
              lineHeight: 1,
            }}
          >
            {isListening ? '⏹' : isModelReady ? '🎙' : '⏳'}
          </button>
        )}
      </div>

      {isListening && (
        <div style={{ fontSize: 11, color: '#ef4444', fontStyle: 'italic' }}>
          🔴 In ascolto… ditta in alfabeto ICAO (es. "Tango Foxtrot zero uno quattro")
        </div>
      )}

      {hint && !isListening && (
        <div style={{ fontSize: 11, color: '#475569' }}>{hint}</div>
      )}
    </div>
  );
};

export default SiglaICAOInput;
